module.exports = {"210682001":"凤凰城街道","210682002":"凤山街道","210682003":"草河街道","210682101":"宝山镇","210682102":"白旗镇","210682103":"沙里寨镇","210682104":"红旗镇","210682105":"蓝旗镇","210682107":"边门镇","210682110":"东汤镇","210682111":"石城镇","210682112":"大兴镇","210682113":"爱阳镇","210682114":"赛马镇","210682115":"弟兄山镇","210682116":"鸡冠山镇","210682117":"刘家河镇","210682118":"通远堡镇","210682119":"四门子镇","210682120":"青城子镇","210682200":"大堡蒙古族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210682.json
// module id = 502
// module chunks = 0